<template>
    <div>
        <v-row>
            <div>
                <div v-if="!value.hasFailedMetrics">
                    <v-chip small>{{value.unitNumber}} ({{value.unitDepartment}})</v-chip>
                </div>
                <div v-if="!!value.hasFailedMetrics">
                    <v-chip small class="red white--text">{{value.unitNumber}} ({{value.unitDepartment}})</v-chip>
                </div>
            </div>
            <v-menu>
                <template v-slot:activator="{ on }">
                    <v-btn height="24" icon text x-small v-on="on" @click="handleClick">
                        <v-icon>info</v-icon>
                    </v-btn>
                </template>
                <v-list>
                    <v-list-item three-line>
                        <v-list-item-content>
                            <v-list-item-title>{{value.unitNumber}} ({{value.unitDepartment}})</v-list-item-title>
                            <v-list-item-subtitle>{{value.unitName}}</v-list-item-subtitle>
                            <v-list-item-subtitle>{{value.unitGarageLocation}}</v-list-item-subtitle>
                            <v-list-item-subtitle>{{value.unitInstallationAddress}}</v-list-item-subtitle>
                        </v-list-item-content>
                        <v-spacer/>
                        <v-chip v-if="!!value.hasFailedMetrics" class="red white--text">Failed Metrics</v-chip>
                        &nbsp;
                        <v-chip v-if="!!value.isLowUse" class="purple lighten-2 white--text">Low Use Unit</v-chip>
                    </v-list-item>
                </v-list>
            </v-menu>
        </v-row>
    </div>
</template>

<script>
  export default {
    props: ['value'],
    methods: {
      handleClick(e) {
        e.stopPropagation();
        e.preventDefault();
      }
    }
  };
</script>
